import { axiosInstance, getAPI, postAPI } from "../utils/api"
import endpoints from "../utils/endpoints"

export const getAllOrders = (payload, callback, errorcallback) => {
    return (dispatch) => {
        const queryParams = {
            page: payload?.page ?? 0,
            size: payload?.size ?? 20,
            search: payload?.search || undefined,
            userId: payload?.userId || undefined,
            orderId: payload?.orderId || undefined,
            transactionId: payload?.transactionId || undefined,
            productCode: payload?.productCode || undefined,
            paymentMode: payload?.paymentMode || undefined,
            paymentStatus: payload?.paymentStatus || undefined,
            minAmount: payload?.minAmount ?? undefined,
            maxAmount: payload?.maxAmount ?? undefined,
            createdFrom: payload?.createdFrom || undefined,
            createdTo: payload?.createdTo || undefined,
        };
        getAPI(
            endpoints?.GET_ALL_ORDERS,
            queryParams,
            (data) => {
                callback(data);
            }, (err) => {
                errorcallback(err);
            },localStorage.getItem('token')
        )
    }
}

export const getWeeklyOrders = (callback, errorcallback) => {
    return (dispatch) => {
        getAPI(
            endpoints?.GET_WEEKLY_ORDERS,
            {},
            (data) => {
                callback(data);
            }, (err) => {
                errorcallback(err);
            },localStorage.getItem('token')
        )
    }
}

export const getOrderRetryAttempts = (params, callback, errorcallback) => {
    return (dispatch) => {
        const queryParams = {};
        if (params?.orderId) queryParams.orderId = params.orderId;
        if (params?.transactionId) queryParams.transactionId = params.transactionId;

        getAPI(
            endpoints.GET_ORDER_RETRY_ATTEMPTS,
            queryParams,
            (data) => callback(data),
            (err) => errorcallback(err),
            localStorage.getItem('token')
        );
    };
};

export const retryOrderDelivery = (body, callback, errorcallback) => {
    return (dispatch) => {
        postAPI(
            endpoints.RETRY_ORDER_DELIVERY,
            body,
            (data) => callback(data),
            (err) => errorcallback(err),
            localStorage.getItem('token')
        );
    };
};

export const getUsersWithOrders = (payload, callback, errorcallback) => {
    return (dispatch) => {
        const queryParams = {
            page: payload?.page ?? 0,
            size: payload?.size ?? 20,
        };
        if (payload?.search !== undefined && payload?.search !== null && String(payload.search).trim() !== '') {
            queryParams.search = String(payload.search).trim();
        }
        if (payload?.role !== undefined && payload?.role !== null && String(payload.role).trim() !== '') {
            queryParams.role = payload.role;
        }
        if (payload?.active !== undefined && payload?.active !== null && payload?.active !== '') {
            queryParams.active = payload.active;
        }
        if (payload?.orderStatus !== undefined && payload?.orderStatus !== null && String(payload.orderStatus).trim() !== '') {
            queryParams.orderStatus = payload.orderStatus;
        }

        const token = localStorage.getItem('token');

        getAPI(
            endpoints.GET_USERS_ORDERS,
            queryParams,
            (data) => {
                if (typeof callback === 'function') callback(data);
            },
            (err) => {
                if (err?.response?.status === 404) {
                    getAPI(
                        endpoints.GET_USERS_WITH_ORDERS,
                        queryParams,
                        (fallbackData) => {
                            if (typeof callback === 'function') callback(fallbackData);
                        },
                        (fallbackErr) => {
                            if (fallbackErr?.response?.status === 404) {
                                getAPI(
                                    endpoints.GET_ORDERS_USERS,
                                    queryParams,
                                    (thirdData) => {
                                        if (typeof callback === 'function') callback(thirdData);
                                    },
                                    (thirdErr) => {
                                        if (typeof errorcallback === 'function') errorcallback(thirdErr);
                                    },
                                    token
                                );
                            } else if (typeof errorcallback === 'function') {
                                errorcallback(fallbackErr);
                            }
                        },
                        token
                    );
                } else if (typeof errorcallback === 'function') {
                    errorcallback(err);
                }
            },
            token
        );
    };
};

export const getUserOrdersById = (userId, payload, callback, errorcallback) => {
    return (dispatch) => {
        const endpoint = endpoints.GET_USER_ORDERS_BY_ID.replace(':id', userId);
        const queryParams = {
            page: payload?.page ?? 0,
            size: payload?.size ?? 50,
            ...(payload?.orderStatus ? { orderStatus: payload.orderStatus } : {}),
            ...(payload?.search ? { search: payload.search } : {}),
        };
        getAPI(
            endpoint,
            queryParams,
            (data) => {
                if (typeof callback === 'function') callback(data);
            },
            (err) => {
                if (typeof errorcallback === 'function') errorcallback(err);
            },
            localStorage.getItem('token')
        );
    };
};

export const downloadOrderInvoice = (orderId, callback, errorcallback) => {
    return (dispatch) => {
        const token = localStorage.getItem('token');
        const primaryEndpoint = (endpoints.DOWNLOAD_ORDER_INVOICE || '/api/orders/:id/invoice').replace(':id', orderId);
        const adminEndpoint = (endpoints.DOWNLOAD_ORDER_INVOICE_ADMIN || '/api/orders/admin/:id/invoice').replace(':id', orderId);
        const altEndpoint = (endpoints.DOWNLOAD_ORDER_INVOICE_DOWNLOAD || '/api/orders/:id/invoice/download').replace(':id', orderId);

        const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

        axiosInstance
            .get(primaryEndpoint, {
                responseType: 'blob',
                headers: authHeaders,
                withCredentials: true,
            })
            .then((response) => {
                if (typeof callback === 'function') callback(response);
            })
            .catch((error) => {
                if (error?.response?.status === 404) {
                    axiosInstance
                        .get(adminEndpoint, {
                            responseType: 'blob',
                            headers: authHeaders,
                            withCredentials: true,
                        })
                        .then((res2) => {
                            if (typeof callback === 'function') callback(res2);
                        })
                        .catch((err2) => {
                            if (err2?.response?.status === 404) {
                                axiosInstance
                                    .get(altEndpoint, {
                                        responseType: 'blob',
                                        headers: authHeaders,
                                        withCredentials: true,
                                    })
                                    .then((res3) => {
                                        if (typeof callback === 'function') callback(res3);
                                    })
                                    .catch((err3) => {
                                        if (typeof errorcallback === 'function') errorcallback(err3);
                                    });
                            } else if (typeof errorcallback === 'function') {
                                errorcallback(err2);
                            }
                        });
                } else if (typeof errorcallback === 'function') {
                    errorcallback(error);
                }
            });
    };
};